// MINDSPACE READING ROOM - Mock Data

export const businessInfo = {
  name: "MINDSPACE READING ROOM",
  tagline: "Your Perfect Study Destination",
  description: "A peaceful and well-equipped study space designed for students and competitive exam aspirants. Focus better, achieve more.",
  address: {
    line1: "GROUND FLOOR, 4-81, Satyasaiangar",
    line2: "Kesavayana Gunta, Padmavati Nagar",
    city: "Tirupati",
    state: "Andhra Pradesh",
    pincode: "517503"
  },
  phone: "9398869329",
  whatsapp: "9398869329",
  email: "mindspacereadingroom@gmail.com",
  hours: {
    open: "7:00 AM",
    close: "10:00 PM",
    days: "All Days"
  },
  googleMapsUrl: "https://maps.google.com/?q=JC7H%2BF6+Tirupati+Andhra+Pradesh"
};

export const pricing = [
  {
    id: 1,
    name: "Focus Starter Plan",
    duration: "1 Month",
    price: 1500,
    perMonth: 1500,
    savings: null,
    badge: null,
    bestFor: "Best for short-term or trial users",
    features: [
      "Quiet & disciplined study environment",
      "High-speed Wi-Fi",
      "Clean, well-lit seating",
      "Power sockets at every desk",
      "Free drinking water"
    ]
  },
  {
    id: 2,
    name: "Focus Saver Plan",
    duration: "3 Months",
    price: 4200,
    perMonth: 1400,
    savings: 300,
    badge: null,
    bestFor: "Better value than monthly",
    features: [
      "All Focus Starter benefits",
      "Priority seat availability",
      "Better value than monthly"
    ]
  },
  {
    id: 3,
    name: "Focus Pro Plan",
    duration: "6 Months",
    price: 7800,
    perMonth: 1300,
    savings: 1200,
    badge: "Most Popular",
    bestFor: "Less renewals, more focus",
    features: [
      "All Focus Starter benefits",
      "Fixed seat preference",
      "Less renewals, more focus"
    ]
  },
  {
    id: 4,
    name: "Focus Elite Plan",
    duration: "12 Months",
    price: 14400,
    perMonth: 1200,
    savings: 3600,
    badge: "Best Value",
    bestFor: "Ideal for competitive exam aspirants",
    features: [
      "All benefits included",
      "Maximum savings",
      "Ideal for competitive exam aspirants"
    ]
  }
];

export const facilities = [
  {
    id: 1,
    title: "Air Conditioned",
    description: "Comfortable AC environment for focused studying",
    icon: "Snowflake"
  },
  {
    id: 2,
    title: "High-Speed Wi-Fi",
    description: "Uninterrupted internet for research and online classes",
    icon: "Wifi"
  },
  {
    id: 3,
    title: "36 Dedicated Seats",
    description: "Personal cubicles with privacy partitions",
    icon: "Users"
  },
  {
    id: 4,
    title: "Free Parking",
    description: "Secure parking space for two-wheelers and cars",
    icon: "Car"
  },
  {
    id: 5,
    title: "Clean Restrooms",
    description: "Well-maintained and hygienic restroom facilities",
    icon: "Bath"
  },
  {
    id: 6,
    title: "Peaceful Environment",
    description: "Distraction-free zone for maximum productivity",
    icon: "Volume2"
  }
];

export const gallery = [
  {
    id: 1,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/2d61kgip_image.png",
    alt: "MINDSPACE Reading Room Overview",
    caption: "Quiet Reading Study Room - Complete Facility"
  },
  {
    id: 2,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/dargsfsp_WhatsApp%20Image%202026-01-12%20at%2011.13.04.jpeg",
    alt: "Building Entrance",
    caption: "Our welcoming entrance"
  },
  {
    id: 3,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/bzx903bb_WhatsApp%20Image%202026-01-12%20at%2011.13.05%20%281%29.jpeg",
    alt: "Study Area",
    caption: "AC study room with individual desks"
  },
  {
    id: 4,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/sl3xnlku_WhatsApp%20Image%202026-01-12%20at%2011.13.05.jpeg",
    alt: "Reading Cubicles",
    caption: "Privacy partitions for focused study"
  },
  {
    id: 5,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/o8wtuuqt_WhatsApp%20Image%202026-01-12%20at%2011.13.07.jpeg",
    alt: "Restroom Facilities",
    caption: "Clean and hygienic restrooms"
  },
  {
    id: 6,
    src: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/khv5uvqs_WhatsApp%20Image%202026-01-12%20at%2011.13.08.jpeg",
    alt: "Building Exterior",
    caption: "Our building exterior view"
  }
];

// Featured promotional image
export const featuredImage = "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/2d61kgip_image.png";

export const testimonials = [
  {
    id: 1,
    name: "Ravi Kumar",
    exam: "UPSC Aspirant",
    quote: "The peaceful environment here helped me focus on my preparation. Highly recommended for serious students!",
    rating: 5
  },
  {
    id: 2,
    name: "Priya Sharma",
    exam: "CA Student",
    quote: "Best reading room in Tirupati! AC, Wi-Fi, and clean facilities - everything a student needs.",
    rating: 5
  },
  {
    id: 3,
    name: "Suresh Reddy",
    exam: "Bank Exam Preparation",
    quote: "The individual cubicles provide great privacy. I can study without any distractions.",
    rating: 5
  }
];

export const stats = [
  { label: "Seats Available", value: "36" },
  { label: "Monthly Fee", value: "₹1500" },
  { label: "Hours Open", value: "15+" },
  { label: "Happy Students", value: "100+" }
];

// Indian Rags to Riches Success Stories through Education
export const successStories = [
  {
    id: 1,
    name: "Dr. APJ Abdul Kalam",
    title: "From Newspaper Boy to President",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/fm7rxhxt_abdul%20kalam.jpg",
    fallbackInitial: "AK",
    story: "Born in a poor Tamil family in Rameswaram, young Kalam sold newspapers to support his family's income. Through relentless reading and dedication to education, he became India's top scientist and the 11th President of India.",
    quote: "You have to dream before your dreams can come true.",
    achievement: "Missile Man of India & 11th President"
  },
  {
    id: 2,
    name: "Dhirubhai Ambani",
    title: "From Gas Station Attendant to Billionaire",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/cd1zwcv8_ambani.jpg",
    fallbackInitial: "DA",
    story: "Started as a gas station attendant in Yemen, Dhirubhai educated himself about business through reading and observation. He built Reliance Industries, making it one of India's largest conglomerates.",
    quote: "If you don't build your dream, someone else will hire you to help them build theirs.",
    achievement: "Founder of Reliance Industries"
  },
  {
    id: 3,
    name: "Dr. B.R. Ambedkar",
    title: "From Untouchable to Architect of Constitution",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/n09x3okj_images.jpg",
    fallbackInitial: "BA",
    story: "Born into an 'untouchable' Dalit family, Ambedkar faced severe discrimination. Through education and voracious reading, he earned degrees from Columbia and London School of Economics, becoming the chief architect of India's Constitution.",
    quote: "Cultivation of mind should be the ultimate aim of human existence.",
    achievement: "Father of Indian Constitution"
  },
  {
    id: 4,
    name: "Kalpana Chawla",
    title: "From Small Town Karnal to Space",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/44a6chmx_kalpana%20chawla.jpg",
    fallbackInitial: "KC",
    story: "From a small town in Haryana where girls' education wasn't prioritized, Kalpana's love for reading about aviation and aerospace led her to become the first Indian-born woman in space.",
    quote: "The path from dreams to success does exist. May you have the vision to find it.",
    achievement: "First Indian Woman Astronaut"
  },
  {
    id: 5,
    name: "Sundar Pichai",
    title: "From Chennai Middle-Class to Google CEO",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/xnyeor90_sundar%20pichai.webp",
    fallbackInitial: "SP",
    story: "Growing up in a modest two-room apartment in Chennai without a car or TV, Pichai excelled through education. His dedication to learning took him from IIT Kharagpur to becoming CEO of Google and Alphabet.",
    quote: "A person who is happy is not because everything is right in his life. He's happy because his attitude towards everything in life is right.",
    achievement: "CEO of Google & Alphabet"
  },
  {
    id: 6,
    name: "Lata Mangeshkar",
    title: "From Poverty to Nightingale of India",
    image: "https://customer-assets.emergentagent.com/job_496184b7-593b-4859-bb3a-d5c15f25a87d/artifacts/o728gcor_image.png",
    fallbackInitial: "LM",
    story: "After losing her father at 13, Lata had to support her family. She educated herself in music through relentless practice and learning, recording over 25,000 songs in 36 languages.",
    quote: "I have always been a learner because I know nothing.",
    achievement: "Bharat Ratna & Voice of India"
  }
];

// Articles about Reading Transforming Lives
export const readingArticles = [
  {
    id: 1,
    title: "How Reading 30 Minutes Daily Can Transform Your Career",
    category: "Career Growth",
    emoji: "📈",
    summary: "Studies show that reading just 30 minutes daily can significantly boost vocabulary, critical thinking, and problem-solving skills - all crucial for career advancement.",
    keyPoints: [
      "CEOs read an average of 60 books per year",
      "Reading improves communication skills by 40%",
      "Regular readers earn 20% more on average",
      "Builds expertise faster than any other method"
    ],
    source: "Harvard Business Review"
  },
  {
    id: 2,
    title: "The Science Behind Reading and Brain Development",
    category: "Neuroscience",
    emoji: "🧠",
    summary: "Neuroscience research reveals that reading creates new neural pathways, improves memory, and even slows cognitive decline by up to 32%.",
    keyPoints: [
      "Reading activates multiple brain regions simultaneously",
      "Increases grey matter density in the brain",
      "Improves emotional intelligence and empathy",
      "Reduces stress by 68% (more than music or walking)"
    ],
    source: "University of Sussex Research"
  },
  {
    id: 3,
    title: "From Reader to Leader: The Education-Success Connection",
    category: "Leadership",
    emoji: "👑",
    summary: "History's greatest leaders were voracious readers. From Mahatma Gandhi to Warren Buffett, reading has been the common thread of exceptional leadership.",
    keyPoints: [
      "Gandhi read for hours daily, even in prison",
      "Warren Buffett reads 500 pages every day",
      "Bill Gates reads 50 books per year",
      "Elon Musk learned rocket science from books"
    ],
    source: "Forbes Leadership Studies"
  },
  {
    id: 4,
    title: "Breaking the Poverty Cycle Through Education",
    category: "Social Impact",
    emoji: "🌟",
    summary: "UNESCO data shows that if all students in low-income countries had basic reading skills, 171 million people could be lifted out of poverty.",
    keyPoints: [
      "Each year of education increases earnings by 10%",
      "Educated mothers have 50% healthier children",
      "Literacy reduces crime rates by 30%",
      "Education is the most powerful equalizer"
    ],
    source: "UNESCO Global Education Report"
  }
];

// Psychological Study Techniques & Research
export const studyTechniques = [
  {
    id: 1,
    name: "Pomodoro Technique",
    icon: "🍅",
    inventor: "Francesco Cirillo",
    description: "Work in focused 25-minute intervals with 5-minute breaks. After 4 pomodoros, take a longer 15-30 minute break.",
    benefits: ["Reduces mental fatigue", "Improves focus by 40%", "Prevents burnout", "Tracks productivity"],
    howTo: "Set timer for 25 mins → Focus completely → 5 min break → Repeat"
  },
  {
    id: 2,
    name: "Feynman Technique",
    icon: "🎓",
    inventor: "Richard Feynman (Nobel Laureate)",
    description: "Learn by teaching. Explain concepts in simple terms as if teaching a child. If you can't explain it simply, you don't understand it well enough.",
    benefits: ["Identifies knowledge gaps", "Deepens understanding", "Improves retention by 90%", "Makes learning active"],
    howTo: "Study topic → Explain simply → Identify gaps → Simplify further"
  },
  {
    id: 3,
    name: "Spaced Repetition",
    icon: "📅",
    inventor: "Hermann Ebbinghaus",
    description: "Review information at increasing intervals. Based on the 'forgetting curve' research showing how memory decays over time.",
    benefits: ["Fights forgetting curve", "Long-term retention", "Efficient studying", "Science-backed method"],
    howTo: "Review Day 1 → Day 3 → Day 7 → Day 14 → Day 30"
  },
  {
    id: 4,
    name: "Active Recall",
    icon: "🔄",
    inventor: "Cognitive Psychology Research",
    description: "Test yourself instead of passive re-reading. Actively retrieving information strengthens memory pathways.",
    benefits: ["3x better than re-reading", "Builds strong memory", "Identifies weak areas", "Exam-ready preparation"],
    howTo: "Read → Close book → Write what you remember → Check → Repeat"
  },
  {
    id: 5,
    name: "Mind Mapping",
    icon: "🗺️",
    inventor: "Tony Buzan",
    description: "Visual learning technique connecting ideas in a radial, non-linear format. Mimics how the brain naturally processes information.",
    benefits: ["Improves creativity", "Shows connections", "Easy to review", "Engages both brain hemispheres"],
    howTo: "Central idea → Branch main topics → Sub-branches → Colors & images"
  },
  {
    id: 6,
    name: "The 80/20 Rule (Pareto Principle)",
    icon: "📊",
    inventor: "Vilfredo Pareto",
    description: "Focus on the 20% of content that gives 80% of results. Identify high-yield topics and prioritize them.",
    benefits: ["Maximum efficiency", "Reduces overwhelm", "Strategic studying", "Better time management"],
    howTo: "Identify key topics → Focus on high-weightage areas → Master fundamentals first"
  }
];

// Famous Thinkers on Reading & Education
export const thinkerQuotes = [
  {
    id: 1,
    name: "Swami Vivekananda",
    quote: "Education is the manifestation of the perfection already in man.",
    image: "🙏"
  },
  {
    id: 2,
    name: "Mahatma Gandhi",
    quote: "Live as if you were to die tomorrow. Learn as if you were to live forever.",
    image: "☮️"
  },
  {
    id: 3,
    name: "Albert Einstein",
    quote: "The only thing that interferes with my learning is my education.",
    image: "🔬"
  },
  {
    id: 4,
    name: "Nelson Mandela",
    quote: "Education is the most powerful weapon which you can use to change the world.",
    image: "✊"
  },
  {
    id: 5,
    name: "Rabindranath Tagore",
    quote: "Don't limit a child to your own learning, for he was born in another time.",
    image: "🪶"
  },
  {
    id: 6,
    name: "Dr. Sarvepalli Radhakrishnan",
    quote: "Books are the means by which we build bridges between cultures.",
    image: "📚"
  }
];

// Pathways to Effective Reading
export const readingPathways = [
  {
    id: 1,
    title: "Start Small, Think Big",
    icon: "🌱",
    description: "Begin with 10 pages daily. Small consistent habits beat occasional marathons.",
    tip: "Set a fixed reading time - morning or before bed works best."
  },
  {
    id: 2,
    title: "Choose the Right Environment",
    icon: "🏠",
    description: "A quiet, well-lit space like MINDSPACE boosts concentration by 60%.",
    tip: "Eliminate phone distractions - use airplane mode while reading."
  },
  {
    id: 3,
    title: "Take Strategic Notes",
    icon: "📝",
    description: "Writing while reading improves retention by 50%. Summarize each chapter.",
    tip: "Use the Cornell note-taking method for structured learning."
  },
  {
    id: 4,
    title: "Discuss What You Learn",
    icon: "💬",
    description: "Teaching others cements your understanding. Join study groups.",
    tip: "Explain concepts to friends or family in simple language."
  },
  {
    id: 5,
    title: "Apply Knowledge Immediately",
    icon: "⚡",
    description: "Use what you learn within 24 hours. Application beats memorization.",
    tip: "Solve practice problems or write about new concepts."
  },
  {
    id: 6,
    title: "Review Regularly",
    icon: "🔁",
    description: "Spaced repetition prevents forgetting. Review notes weekly.",
    tip: "Create flashcards for key concepts and formulas."
  }
];

// Recommended Study Tools
export const studyTools = [
  {
    id: 1,
    name: "BreatheFlow",
    tagline: "Calm Your Mind Before You Study",
    url: "https://breatheflow.live/",
    icon: "🧘",
    color: "from-cyan-400 to-teal-500",
    description: "A simple, beautiful breathing exercise tool to reduce stress and anxiety before your study sessions. Science shows that controlled breathing increases focus by 40% and reduces exam anxiety.",
    features: [
      "Guided breathing exercises",
      "Adjustable speed (Slow/Normal/Fast)",
      "Mood tracking",
      "No signup required - 100% free"
    ],
    benefit: "Use for 2-3 minutes before studying to enter a calm, focused state. Perfect for exam preparation!"
  }
];


